import { useRef } from "react";
import { ExternalLink, ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";

// Featured articles for homepage teaser - ordered by publish date (newest first)
const featuredArticles = [
  {
    title: "What Skillful Cold Calling Should Teach Us About Hiring Sales Talent",
    hook: "The traits for successful cold calling are the same qualities to prioritize when hiring.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/what-skillful-cold-calling-should-teach-us-hiring-sales-dan-leitner-cjgne/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/28a36716d3f21e22_Screenshot%202026-10-07%20at%204.23.15%E2%80%AFPM.png",
    isNew: true
  },
  {
    title: "The 5 Biggest Mistakes Sales Leaders Make When Building an SDR Team",
    hook: "Five leadership mistakes including overvaluing experience and scaling too early.",
    tag: "Leadership",
    link: "https://www.linkedin.com/pulse/5-biggest-mistakes-sales-leaders-make-when-building-sdr-dan-leitner-y1xse/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/9d62d125df5bf411_Screenshot%202026-10-07%20at%204.23.05%E2%80%AFPM.png",
    isNew: true
  },
  {
    title: "The Anatomy of Top Tier SDR Talent",
    hook: "The six core traits that define high-potential SDRs.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/anatomy-top-tier-sdr-talent-dan-leitner-5eqje/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/qn4uxax1_image.png"
  },
  {
    title: "Betting on Talent: What to Look for in Your Next GTM Hire",
    hook: "Hire for business impact, learning speed, and system building ability.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/betting-talent-what-look-your-next-gtm-hire-dan-leitner-3tggc/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/a60buryb_Screenshot%202026-07-30%20at%2011.08.43%E2%80%AFAM.png"
  },
  {
    title: "The Power of the Pause",
    hook: "Why restraint—not just urgency—separates top performers in sales and leadership.",
    tag: "Leadership",
    link: "https://www.linkedin.com/pulse/power-pause-dan-leitner-jxrkf/",
    image: "https://media.licdn.com/dms/image/v2/D4D12AQFnpfLlPUaRzA/article-cover_image-shrink_720_1280/B4DZ9HnjqZJsAU-/0/1783612983984?e=2147483647&v=beta&t=6ydH3agA6q7tsG2-Nz8MQa3AwwVuK70m5Lu4lvQVBjc"
  },
  {
    title: "The Great Democratization of Creation",
    hook: "What happens when AI gives millions access to capabilities once reserved for the few?",
    tag: "AI",
    link: "https://www.linkedin.com/pulse/great-democratization-creation-dan-leitner-zdwde/",
    image: "https://media.licdn.com/dms/image/v2/D4E12AQFOo9ktGOzApA/article-cover_image-shrink_720_1280/B4EZ7F8eI1IwAU-/0/1781437429676?e=2147483647&v=beta&t=n1ltiHK33k6746HRL6g8umwBXobNRWmQRXWxMGvHuto"
  },
  {
    title: "The Three-Phase SDR System for Trade Show Pipeline",
    hook: "Why trade show success comes down to execution across three phases.",
    tag: "Events",
    link: "https://www.linkedin.com/pulse/three-phase-sdr-system-trade-show-pipeline-dan-leitner-2aiyc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQFqXi-X2TEUEQ/article-cover_image-shrink_720_1280/B56Z3yF9tlKIAI-/0/1777883152570?e=2147483647&v=beta&t=By-v9NqYXrnutFmb_H48dQdtoUlxDBzOLCJO8Bi_Sww"
  },
  {
    title: "Outbound Didn't Die. Leadership Left the Floor.",
    hook: "The market didn't reject outbound—it rejected low-effort outreach at scale.",
    tag: "Leadership",
    link: "https://www.linkedin.com/pulse/outbound-didnt-die-leadership-left-floor-dan-leitner-cfg1c/",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_efficiency-boost-10/artifacts/nfd0u0zd_Screenshot%202026-07-30%20at%2011.53.14%E2%80%AFAM.png"
  },
  {
    title: "The LRS AI SDR Agent Training Playbook",
    hook: "How to build sales agents that actually work in production.",
    tag: "AI + SDR",
    link: "https://www.linkedin.com/pulse/lrs-ai-sdr-agent-training-playbook-dan-leitner-0zmwc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQHCPjDgc_XE_A/article-cover_image-shrink_720_1280/B56Z1ht6VsJ0AI-/0/1775460924383?e=2147483647&v=beta&t=3fFKvz5y3kul8snZrWf8WppC7xzxN16T3rskVZaXrWk"
  },
  {
    title: "How to Design an AI-Powered SDR System That Produces Pipeline",
    hook: "Build SDR systems that scale outreach without sacrificing quality.",
    tag: "AI + SDR",
    link: "https://www.linkedin.com/pulse/how-design-ai-powered-sdr-agent-team-where-most-teams-dan-leitner-q9foc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQHoqD9j6OPvfQ/article-cover_image-shrink_720_1280/B56ZuaiYovKEAI-/0/1767824267682?e=2147483647&v=beta&t=ruFDrcPhUkjhXWmtJ0Syx8_TeZX8JTAYko63S-061Lw"
  },
  {
    title: "Why Most SDR Models Fail Financially",
    hook: "The hidden economics that break SDR teams.",
    tag: "Economics",
    link: "https://www.linkedin.com/pulse/sdr-economics-what-most-business-plans-get-completely-dan-leitner-haame/",
    image: "https://media.licdn.com/dms/image/v2/D4D12AQGGRGuMGAL3mA/article-cover_image-shrink_720_1280/B4DZxTkMADHkAI-/0/1770928527443?e=2147483647&v=beta&t=-2FnyaulHj-TRfafbL3WELljIJJ6RvXNlkv14hi9tLM"
  },
  {
    title: "The Talent System Behind Hyper-Growth",
    hook: "Why entry-level talent pools drive revenue organizations.",
    tag: "Talent",
    link: "https://www.linkedin.com/pulse/talent-system-behind-hyper-growth-why-entry-level-pools-dan-leitner-algrc/",
    image: "https://media.licdn.com/dms/image/v2/D5612AQGWYSSnqjD04Q/article-cover_image-shrink_720_1280/B56Zza7McgH8AI-/0/1773199482538?e=2147483647&v=beta&t=EdThB6PbZGoiEiUeYzUNigz3957oIopIj_ofVkBKV7k"
  }
];

// Article Card Component
const ArticleCard = ({ article, isCarousel = false }) => (
  <a 
    href={article.link}
    target="_blank"
    rel="noopener noreferrer"
    className={`group block bg-[#1C1C1C] rounded-xl overflow-hidden border border-white/5 hover:border-[#D4AF37]/30 transition-all hover:-translate-y-1 ${
      isCarousel ? 'flex-shrink-0 w-[85vw] sm:w-[320px] snap-center mx-2' : ''
    }`}
  >
    <div className="aspect-[16/9] overflow-hidden relative">
      <img 
        src={article.image} 
        alt={article.title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
      />
      {/* NEW Badge */}
      {article.isNew && (
        <div className="absolute top-2 right-2 px-2 py-0.5 bg-[#D4AF37] rounded-full">
          <span className="text-[10px] font-bold text-[#0A0A0A]">NEW</span>
        </div>
      )}
    </div>
    <div className="p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="px-2 py-0.5 bg-[#D4AF37]/10 rounded text-[10px] sm:text-xs font-medium text-[#D4AF37]">
          {article.tag}
        </span>
        <ExternalLink className="w-3.5 h-3.5 text-zinc-400 group-hover:text-[#D4AF37] transition-colors" />
      </div>
      <h3 className="text-sm sm:text-base text-white font-semibold group-hover:text-[#D4AF37] transition-colors line-clamp-2 leading-snug mb-1.5">
        {article.title}
      </h3>
      <p className="text-xs text-zinc-400 line-clamp-1">{article.hook}</p>
    </div>
  </a>
);

// Homepage Insights Teaser with Carousel on Mobile
export const InsightsTeaser = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section id="insights" className="py-12 sm:py-16 lg:py-20 bg-[#0A0A0A]">
      {/* Header */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-white tracking-tight mb-2 sm:mb-3">
            Thinking & Writing
          </h2>
          <p className="text-sm sm:text-base text-zinc-300">
            Dan's writing on Sales Development, hiring, economics, and execution.
          </p>
        </div>
      </div>

      {/* Mobile Carousel */}
      <div className="lg:hidden relative">
        <div 
          ref={scrollRef}
          className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide pb-4 px-4 -mx-2"
          style={{ 
            scrollbarWidth: 'none', 
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          {featuredArticles.map((article) => (
            <ArticleCard key={article.title} article={article} isCarousel={true} />
          ))}
        </div>
        
        {/* Scroll Indicator */}
        <div className="flex justify-center gap-1.5 mt-2">
          {featuredArticles.map((article) => (
            <div 
              key={`dot-${article.title}`}
              className="w-1.5 h-1.5 rounded-full bg-white/20"
            />
          ))}
        </div>
      </div>

      {/* Desktop Grid */}
      <div className="hidden lg:block max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <ArticleCard key={`desktop-${article.title}`} article={article} />
          ))}
        </div>
      </div>

      {/* View All Link */}
      <div className="text-center mt-8 sm:mt-10">
        <a 
          href="/insights"
          className="inline-flex items-center gap-2 text-sm sm:text-base text-[#D4AF37] font-medium hover:text-[#E8C547] transition-colors"
        >
          View All Insights
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
};

export default InsightsTeaser;
